<a
  class="link-reset event-card-container"
  [routerLink]="['/agenda', event().id, event().startDate | date: 'dd-MM-yyyy', event().title | urlRewrite]"
>
  <article
    class="event-card"
    [class.event-card--list-item]="inList()"
    [ngClass]="'event-card--' + theme()"
    [class.is--past-event]="isPastEvent()"
  >
    <figure class="event-card__figure">
      @if (event().label && !isPastEvent()) {
        <span class="badge text-bg-secondary event-card__label">{{ event().label }}</span>
      }
      @if (!event().videoUrl) {
        <img
          class="event-card__figure__media"
          [ngSrc]="event().image?.url || 'https://coda.fstr.io/media/placeholder.png'"
          [width]="500"
          [height]="430"
          [alt]="event().image?.alt || event().image?.caption || event().title"
          ngSrcset="550w, 800w"
          #imgel
          onerror="this.imgel.src='/media/placeholder.png'"
          [loaderParams]="{
            width: 500,
            height: 430,
            anchor: event().image?.anchor || 'middlecenter',
            scale: 'both',
          }"
        />
      }
      @if (event().videoUrl) {
        <app-youtube
          class="event-card__figure__media"
          [url]="event().videoUrl!"
          [cookiePreferences]="cookiePreferences()"
          [previewOnly]="true"
          [color]="theme()"
        ></app-youtube>
      }

      @if (isPastEvent() || hasRecurrencePattern()) {
        <div class="event-card__figure__overlay">
          <ul class="pe-2 ps-2 pt-2 meta-badge-list">
            @if (isPastEvent()) {
              <li class="d-flex">
                <span class="badge text-bg-light">{{ 'event-label-geweest' | fromDictionary }}</span>
              </li>
            }
            @if (hasRecurrencePattern()) {
              <li>
                <span class="badge badge--secondary-subtle">
                  <fstr-icon anchor="line-icon-repeat"></fstr-icon>
                  <span>{{ 'event-label-geweest-is-herhalend' | fromDictionary }}</span>
                </span>
              </li>
            }
            @if (event().label) {
              <li class="overflow-hidden">
                <span class="badge text-bg-secondary event-card__label">{{ event().label }}</span>
              </li>
            }
          </ul>
        </div>
      }
    </figure>
    <main class="event-card__main">
      <div class="event-card__main__meta mb-2">
        <span class="flex-shrink-0" [class.text-decoration-line-through]="isPastEvent()">
          {{ event().startDate | eventDate: event().endDate }}
        </span>

        <span class="text-body-tertiary text-truncate" [class.text-decoration-line-through]="isPastEvent()">
          {{ event() | eventDateTime }}
        </span>
        @if (event().eventType?.name) {
          <span class="text-body-tertiary flex-shrink-0">|</span>
        }

        @if (event().eventType?.name) {
          <span class="text-body-tertiary text-truncate flex-shrink-0">{{ event().eventType?.name }}</span>
        }
      </div>
      <div>
        <h2 class="h5 fw-normal max-lines-3 mb-max-lines">{{ event().title }}</h2>
      </div>
    </main>
  </article>
</a>
